import moment from "moment-timezone";
import GroupExpandRenderer from "src/components/common/AgGrid/GroupExpandRenderer";
import styles from "src/styles/agGridCustom.module.scss";

export const defaultColDef = {
    resizable: true,
    sortable: true,
};

// e.g. 123,456.24
// if the value ends with .00 then the decimal part is removed
function formatCommaDecimal(value) {
    return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: value % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2,
    }).format(value);
}

export const clientPoolPositionsColumnDefs = [
    {
        headerName: "List",
        field: "list_name",
        width: 100,
        minWidth: 100,
        sort: "asc",
        sortIndex: 0,
        headerClass: [styles.agHeaderLeftAlign, styles.agHeaderMergeCenter],
    },
    {
        headerName: "Security",
        field: "security_name",
        width: 150,
        minWidth: 150,
        sort: "asc",
        sortIndex: 1,
        headerClass: [styles.agHeaderLeftAlign, styles.agHeaderMergeCenter],
    },
    {
        headerName: "Ticker",
        field: "ticker",
        width: 100,
        minWidth: 100,
        headerClass: [styles.agHeaderLeftAlign, styles.agHeaderMergeCenter],
    },
    {
        headerName: "Beneficial Owners",
        field: "num_owners",
        width: 150,
        minWidth: 150,
        cellRenderer: GroupExpandRenderer,
        headerClass: [styles.agHeaderRightAlign, styles.agHeaderMergeCenter],
    },
    {
        headerName: "Last Updated",
        field: "last_updated_time",
        width: 120,
        minWidth: 120,
        valueFormatter: ({ value }) =>
            moment
                .utc(value)
                .tz(moment.tz.guess())
                .format("YYYY/MM/DD HH:mm:ss"),
        headerClass: [styles.agHeaderLeftAlign, styles.agHeaderMergeCenter],
    },
    {
        headerName: "Total Lendable Quantity",
        children: [
            {
                headerName: "T0",
                field: "available_quantity_t0",
                width: 100,
                minWidth: 100,
                sort: "desc",
                sortIndex: 2,
                type: "numericColumn",
                headerClass: [styles.agHeaderRightAlign],
                valueFormatter: ({ value }) => formatCommaDecimal(value),
            },
            {
                headerName: "T1",
                field: "available_quantity_t1",
                width: 100,
                minWidth: 100,
                type: "numericColumn",
                headerClass: [styles.agHeaderRightAlign],
                valueFormatter: ({ value }) => formatCommaDecimal(value),
            },
            {
                headerName: "T2",
                field: "available_quantity_t2",
                width: 100,
                minWidth: 100,
                type: "numericColumn",
                headerClass: [styles.agHeaderRightAlign],
                valueFormatter: ({ value }) => formatCommaDecimal(value),
            },
            {
                headerName: "T3",
                field: "available_quantity_t3",
                width: 100,
                minWidth: 100,
                type: "numericColumn",
                headerClass: [styles.agHeaderRightAlign],
                valueFormatter: ({ value }) => formatCommaDecimal(value),
            },
            {
                headerName: "T4",
                field: "available_quantity_t4",
                width: 100,
                minWidth: 100,
                type: "numericColumn",
                headerClass: [styles.agHeaderRightAlign],
                valueFormatter: ({ value }) => formatCommaDecimal(value),
            },
            {
                headerName: "T5",
                field: "available_quantity_t5",
                width: 100,
                minWidth: 100,
                type: "numericColumn",
                headerClass: [styles.agHeaderRightAlign],
                valueFormatter: ({ value }) => formatCommaDecimal(value),
            },
        ],
    },
    {
        // Very hacky way to align master and detail columns
        headerName: "",
        field: "blank_column",
        width: 8,
        minWidth: 8,
        maxWidth: 8,
        resizable: false,
        sortable: false,
        filter: false,
        suppressMenu: true,
        suppressColumnsToolPanel: true,
        suppressMovable: true,
    },
];
